import { useQuery } from '@zoomcatalog/query-client';
import { AxiosError } from 'axios';

import api from '@/config/axios';
import { settings } from '@/settings/DynamicSettings';

export type GeolocationData = {
  ip: string;
  country: string;
  'country-name': string;
  state: string;
  'state-name': string;
  city: string;
};

type GeolocationQueryContext = {
  options?: {
    enabled?: boolean;
  };
  handlers?: {
    onSuccess: (data: GeolocationData | undefined) => void;
  };
};
export function useGeolocationQuery(context?: GeolocationQueryContext) {
  return useQuery<GeolocationData, AxiosError>('geolocation', {
    queryFn: async () =>
      api
        .get<GeolocationData>(settings.GEOLOCATION_URL, {
          baseURL: undefined,
        })
        .then((data) => data.data),
    onSuccess(data) {
      context?.handlers?.onSuccess(data);
    },
    enabled: context?.options?.enabled ?? true,
    staleTime: Infinity,
    refetchOnMount: false,
  });
}
